import { reportMissedPickUpDataEn } from "constants-lib/seo/faqDataImplementation"
import { addJSONLDToHead, removeElement } from "./jsonLD.js"

const getReportMissedPickUpEn = () => {
  const data = reportMissedPickUpDataEn.map((item) => ({
    "@type": `Question`,
    name: item.Question,
    acceptedAnswer: {
      "@type": `Answer`,
      text: item.Answer,
    },
  }))
  return data
}

/* Add FAQ Baster JSON LD if needed, otherwise make sure it does not exist in Head. */
export const addReportMissedPickUp = () => {
  if (
    window.location.href.includes(
      `/us/en/support/faqs/how-do-i-report-a-missed-pickup`,
    ) &&
    document.getElementById(`reportMissedPickUpJSONLD`) === null
  ) {
    const script = ReportMissedPickUpJSONLDEn()
    addJSONLDToHead(script, `reportMissedPickUpJSONLD`)
  } else {
    removeElement(`reportMissedPickUpJSONLD`)
  }
}

// JSON LD template for FAQ Bagster
const ReportMissedPickUpJSONLDEn = () => {
  const FaqBagsterTemplate = {
    "@context": `http://schema.org`,
    "@type": `FAQPage`,
    mainEntity: getReportMissedPickUpEn(),
  }
  return FaqBagsterTemplate
}
